import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {DeviceSelectPage} from './device-select';
import {TranslateModule} from "@ngx-translate/core";
import {DirectivesModule} from "../../directives/directives.module";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';
import {NoResultsComponentModule} from "../../components/no-results/no-results.module";

@NgModule({
  declarations: [
    DeviceSelectPage,
  ],
  imports: [
    HeaderTitleComponentModule,
    IonicPageModule.forChild(DeviceSelectPage),
    TranslateModule.forChild(),
    DirectivesModule,
    NoResultsComponentModule
  ],
  providers: [
  ]
})
export class DeviceSelectPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/device-select/device-select.module.ts